/**
 * mh-cart-discount.js
 * Minimal Home — Cart Drawer discount code entry.
 *
 * IMPORTANT (why this navigates instead of staying "AJAX-only"):
 * Shopify's Ajax Cart API (/cart/add.js, /cart/change.js, /cart/update.js) has no endpoint
 * to apply a manual discount code to the cart in a way that is later honored at checkout.
 * The only mechanism Shopify guarantees will actually work at checkout is the native
 * /discount/{code} redirect endpoint, which associates the code with the buyer's checkout
 * session server-side. We use that endpoint on purpose so the applied discount is REAL
 * (visible in the cart totals and carried through to checkout), not a cosmetic-only field
 * that later fails to apply. This causes one real page navigation back to /cart with the
 * code applied — by design, not a bug.
 */
(function () {
  if (customElements.get('mh-cart-discount')) return;

  class MhCartDiscount extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('[data-mh-discount-form]');
      this.input = this.querySelector('.mh-cart-discount__input');
      this.errorEl = this.querySelector('[data-mh-discount-error]');
      this.submitButton = this.querySelector('.mh-cart-discount__submit');
      if (this.form) {
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }
    }

    onSubmit(event) {
      event.preventDefault();
      const code = (this.input.value || '').trim();

      this.setError('');

      if (!code) {
        this.setError(
          (window.mhCartStrings && window.mhCartStrings.discountEmpty) ||
            'Ingresa un código de descuento.'
        );
        this.input.focus();
        return;
      }

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.submitButton.setAttribute('aria-disabled', 'true');
      this.submitButton.classList.add('loading');
      const spinner = this.submitButton.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const root = (window.routes && window.shopUrl) ? window.shopUrl : '';
      const redirectTo = encodeURIComponent('/cart');
      window.location.href = `${root}/discount/${encodeURIComponent(code)}?redirect=${redirectTo}`;
    }

    setError(message) {
      if (!this.errorEl) return;
      if (message) {
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
      } else {
        this.errorEl.textContent = '';
        this.errorEl.hidden = true;
      }
    }
  }

  customElements.define('mh-cart-discount', MhCartDiscount);
})();
